const ecsHost = process.env.REACT_APP_ECS_HOST as string;
export const ecsClientConfig = {
  ecsAgentName: "VirtualEventsPortal",
  ecsHost,
  ecsClientName: "MicrosoftTeams",
  ecsClientVersion: "1.0.0.0",
};
